import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Calendar } from 'lucide-react';
import { api } from '../lib/api';
import { InlineText } from './InlineEditable';

export default function NewsSection() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.listNews().then(setItems).catch(() => setItems([])); }, []);
  if (!items.length) return null;
  const [featured, ...rest] = items.slice(0, 5);
  return (
    <section className="bg-cream-200">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <InlineText settingKey="home_news_kicker" fallback="Duyurular & Etkinlikler" as="div"
              className="text-[11px] tracking-[0.3em] uppercase text-coral-300 font-semibold" />
            <InlineText settingKey="home_news_title"
              fallback={'Sahadan <span class="italic">haberler</span>.'}
              as="h2" html
              className="font-display text-4xl md:text-5xl lg:text-[56px] mt-4 leading-[1.02] text-ink-600 max-w-3xl" />
          </div>
          <Link to="/duyurular" className="inline-flex items-center gap-2 text-ink-600 font-medium hover:gap-3 transition-all">Tüm duyurular <ArrowUpRight className="w-4 h-4" /></Link>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          <Link to={`/duyurular/${featured.slug}`} className="lg:col-span-7 group rounded-3xl overflow-hidden relative block">
            <div className="aspect-[16/11] bg-ink-700">
              <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-ink-900/90 via-ink-900/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10 text-cream">
              <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest">
                <span className="bg-gold text-ink-700 rounded-full px-3 py-1 font-semibold">{featured.category}</span>
                <span className="opacity-75 inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {featured.date}</span>
              </div>
              <h3 className="font-display text-3xl md:text-4xl lg:text-5xl mt-4 leading-tight max-w-2xl">{featured.title}</h3>
              <p className="mt-3 text-cream/80 max-w-xl text-sm md:text-base">{featured.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-2 font-medium">Devamını oku <ArrowUpRight className="w-4 h-4" /></span>
            </div>
          </Link>

          <div className="lg:col-span-5 flex flex-col gap-4">
            {rest.map((n) => (
              <Link to={`/duyurular/${n.slug}`} key={n.id} className="group grid grid-cols-5 gap-4 items-stretch bg-white rounded-2xl p-4 border border-ink-100 hover:border-gold transition-colors">
                <div className="col-span-2 aspect-square rounded-xl overflow-hidden bg-ink-50">
                  <img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="col-span-3 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-ink-400">
                      <span className="text-gold-500 font-semibold">{n.category}</span>·<span>{n.date}</span>
                    </div>
                    <h4 className="font-display text-lg md:text-xl mt-2 text-ink-600 leading-snug group-hover:text-ink-500">{n.title}</h4>
                  </div>
                  <span className="text-xs text-ink-500 inline-flex items-center gap-1 mt-2">Oku <ArrowUpRight className="w-3.5 h-3.5" /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
